import DataRetriever from './DataRetriever.js';
import ValueCollection from './ValueCollection.js';
import ReferencesTransformer from './ReferencesTransformer.js';
import NumericFormat from './NumericFormat.js';
import adapters from './adapters/index.js';
import availability from './availability/index.js';
import data from './data/index.js';
import features from './features/index.js';
import geodata from './geodata/index.js';
import customerMetadata from './customer-metadata/index.js';
import systemMetadata from './system-metadata/index.js';
function configure({ domain, protocol }) {
    availability.configure({ domain, protocol });
    geodata.configure({ domain, protocol });
    customerMetadata.configure({ domain, protocol });
    systemMetadata.configure({ domain, protocol });
}
const { DataReference, DataImplementation, DataReferenceCollection } = data;
const { FeatureReference, FeatureReferenceCollection } = features;
// Configure
export { configure, DataRetriever, ValueCollection, ReferencesTransformer, NumericFormat, };
// Collections
export { adapters, availability, data, features, geodata, systemMetadata, customerMetadata };
// Data References
export { DataReference, DataReferenceCollection, DataImplementation };
// Feature References
export { FeatureReference, FeatureReferenceCollection };
// Bundle
export default {
    adapters,
    availability,
    data,
    features,
    geodata,
    configure,
    systemMetadata,
    customerMetadata,
    DataRetriever,
    ValueCollection,
    ReferencesTransformer,
    NumericFormat,
};
